import React from "react";
import {
  answerTypes,
  getType,
  extractNameFromBase64File
} from "../ReviewStep/review-step-utils";

export const AnswerObject = ({ title, value, url, ...rest }) => {
  return (
    <>
      {title ? (
        <div>
          <h1>{title}</h1>
          {Object.entries(value).map(([title, value]) => (
            <Answer title={title} value={value} key={title} {...rest} />
          ))}
          {/* </Definition> */}
        </div>
      ) : (
        Object.entries(value).map(([title, value]) => (
          <Answer title={title} value={value} key={title} {...rest} />
        ))
      )}
    </>
  );
};

export const AnswerArray = ({ title, value, ...rest }) =>
  value.map((answer, index) => (
    <div style={{ marginBottom: 36 }} key={index}>
      <h2>
        {title} {index + 1}
      </h2>
      <Answer title={answer.title} value={answer} key={index} />
    </div>
  ));

// TODO: Print boolean values as strings
export const AnswerPlain = ({ title, value, ...rest }) =>
  value && (
    <div>
      <strong>{title}: </strong>
      <span style={{ whiteSpace: "pre-wrap" }}>{value}</span>
    </div>
  );

export const AnswerFile = ({ value, ...rest }) => (
  <div>
    <dt>Filnamn</dt>
    <dd>{extractNameFromBase64File(value)}</dd>
  </div>
);

const Answer = ({ title, value = "-", ...rest }) => {
  switch (getType(value)) {
    case answerTypes.UNDEFINED:
    case answerTypes.PLAIN:
      return <AnswerPlain {...rest} key={title} title={title} value={value} />;
    case answerTypes.FILE:
      return <AnswerFile {...rest} value={value} />;
    case answerTypes.OBJECT:
      return <AnswerObject {...rest} key={title} title={title} value={value} />;
    case answerTypes.ARRAY:
      return <AnswerArray {...rest} key={title} title={title} value={value} />;
    default:
      return <div key={title}>not implemented</div>;
  }
};

export default Answer;
